import React from 'react';
import {Route, Routes} from 'react-router-dom';
import NavLink from './../../../common/nav_link'
import $ from 'jquery';

class RoutingWrapper extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            routes: [
                {type: 'route', url: 'groups', name: 'Routing Groups'},
                {type: 'route', url: 'master', name: 'Master List'},
                {type: 'route', url: 'srcnumbers', name: 'Source Numbers'}
            ]
        }
    }
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h2>SMS Routing</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <ul className="nav nav-tabs">
                            {this.state.routes.map(function(row, index) {
                                return (
                                    <NavLink
                                        key={ index }
                                        to={`/routing/sms/${ row.url }`}
                                        default={`/routing/sms/groups`}
                                    >
                                        { row.name }
                                    </NavLink>
                                )
                            }, this)}
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default class extends React.Component {
    render() {
        return (
            <div>
                <RoutingWrapper urlattrs={this.props.urlattrs} />
                <Routes>
                    {this.props.routes.map((route, i) => (
                        <Route key={i} path={route.path} 
                            element={<route.component routes={route.routes} childProps={this.props.childProps}/>} 
                        />
                    ))}
                </Routes>
            </div>
        )
    }
}